import { Button, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "@common/Login/css/Login.scss";
import { useEmailVerification } from "./hook/useEmailVerification";
import { EmailVerificationStep } from "@pages/EmailVerification/EmailVerificationPage";
import { emailRegex } from "@utils/formControl";
import { Loader } from "@common/Loader/Loader";

interface IParams {
    setStep(step: EmailVerificationStep): void;
}

export const EmailVerificationForm = (props: IParams) => {
    const { t } = useTranslation(["forgotEmail", "common", "validation"]);
    const { setStep } = props;
    const { formMethods, submitEmail, postEmailVerificationState } = useEmailVerification(setStep);

    const { register, errors } = formMethods;

    return (
        <form onSubmit={submitEmail}>
            <Grid alignItems="center" container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        error={Boolean(errors.email)}
                        fullWidth
                        helperText={errors.email?.message}
                        id="emailVerification"
                        inputRef={register({
                            required: t("validation:required"),
                            validate: emailRegex,
                        })}
                        label={t("forgotEmail:emailAddress")}
                        margin="dense"
                        name="email"
                        type="email"
                    />
                </Grid>
                <Grid item xs={12}>
                    {postEmailVerificationState.isLoading && <Loader size={40} />}
                    {!postEmailVerificationState.isLoading && (
                        <Button color="secondary" fullWidth type="submit" variant="contained">
                            {t("common:continue")}
                        </Button>
                    )}
                </Grid>
            </Grid>
            {postEmailVerificationState.error && (
                <Grid item>
                    <Typography color="error">
                        {postEmailVerificationState.error.errorMessage || t("common:genericError")}
                    </Typography>
                </Grid>
            )}
        </form>
    );
};
